import randomColor from "randomcolor";
import { getPersistenceData } from "./persistenceStorage";
import * as Sentry from "@sentry/vue";
const isProduction = process.env.NODE_ENV === "production";
const logEnabled = () => (isProduction ? getPersistenceData("logEnabled") != null : true);
const colors = {
    error: "red",
    warn: "orange",
    debug: "grey",
    info: "teal",
    textColor: "white",
};
const levelStyles = {
    error: `background: ${colors.error}; color: ${colors.textColor}`,
    warn: `background: ${colors.warn}; color: ${colors.textColor}`,
    debug: `background: ${colors.debug}; color: ${colors.textColor}`,
    info: `background: ${colors.info}; color: ${colors.textColor}`,
};
export const log2 = (prefix, salt) => {
    const logFn =
        (level) =>
        (...messages) => {
            const levelStyle = levelStyles[level];
            if (logEnabled()) {
                prefix = prefix || "PREFIX";
                const _prefix = `[${prefix}]`;
                const prefixStyle = generatePrefixStyle(prefix + salt + globalSalt);
                console.log(
                    `%c ${_prefix} %c  %c ${level.toUpperCase()} `,
                    prefixStyle,
                    restStyle,
                    levelStyle,
                    ...messages
                );
            }
            if (level === "error") {
                if (messages[0]) Sentry.captureMessage(`${prefix} ${messages[0]}`);
            }
        };

    const result = logFn("info");
    result.debug = logFn("debug");
    result.error = logFn("error");
    result.warn = logFn("warn");
    result.info = logFn("info");
    return result;
};
const generatePrefixStyle = (seed) => {
    const foreground = randomColor({ luminosity: "dark", seed });
    const background = randomColor({ luminosity: "light", seed });
    return `background: ${background}; color: ${foreground};`;
};
const restStyle = "";
const globalSalt = "dasd";

export default log2;
window.log2 = log2;



// WEBPACK FOOTER //
// ./src/utils/log2.js